import { PlanoRefeicaoAlimento } from "./PlanoRefeicaoAlimento";

export class PlanoRefeicaoOpcao {
  idOpcao?: number;
  titulo!: string;
  alimentos?: PlanoRefeicaoAlimento[];
}
